import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FeatureIcon = function FeatureIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8.24085 0.420875C8.59871 -0.140026 9.39429 -0.140351 9.75258 0.420257L13.3483 6.04653C13.7464 6.66936 13.3145 7.5 12.5927 7.5H5.40734C4.6858 7.5 4.25388 6.67002 4.65128 6.04714L8.24085 0.420875Z",
      fill: "#FF6575"
    }), /*#__PURE__*/_jsx("path", {
      d: "M0 11.25C0 10.8358 0.335786 10.5 0.75 10.5H6.75C7.16421 10.5 7.5 10.8358 7.5 11.25V17.25C7.5 17.6642 7.16421 18 6.75 18H0.75C0.335787 18 0 17.6642 0 17.25V11.25Z",
      fill: "#FF6575"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18 14.25C18 16.3211 16.3211 18 14.25 18C12.1789 18 10.5 16.3211 10.5 14.25C10.5 12.1789 12.1789 10.5 14.25 10.5C16.3211 10.5 18 12.1789 18 14.25Z",
      fill: "#FF6575"
    })]
  });
};

export default FeatureIcon;